export default {
    SET_NOTIFICATIONS: (state, notifications) => {
        state.notifications = notifications
    },
    SET_NOTIFICATIONS_HISTORY: (state, notificationsHistory) => {
        state.notificationsHistory = notificationsHistory
    },
    SET_PAGINATION: (state, pagination) => {
        state.pagination.length = pagination.length || state.pagination.length
        state.pagination.page = pagination.page || state.pagination.page
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_NOTIFICATIONS: (state) => {
        state.filters = {
            types: [],
            fromDate: null,
            toDate: null
        }
    }
}
